<template>
  <div>
    <div class="form">


      <el-form label-width="80px" :model="formData" ref="form">
        <action-group></action-group>

        <div
            class="form-item-box"
            v-for="(d, idx) in formData.portionSizeList"
            :key="d + '_form_' + idx"
        >
          <i
              v-if="!disabled"
              class="el-icon-circle-close close-icon"
              @click="handleRemoveDeal(idx)"
          />

          <el-form-item :label="$t('lang.份量') + '：'" style="width: 300px" :rules="portionSizeRule" :prop="`portionSizeList[${idx}].portionSize`" required>
            <nation-input
                :placeholder="$t('lang.如3-5人份')"
                :list="selectLang"
                v-model="d.portionSize"
                @blur="handleBlurFoodSize"
                :lang="lang"
                :disabled="disabled"/>
          </el-form-item>

          <el-form-item :label="$t('lang.食材') + '：'" required>
            <food-ingredient
                v-for="(i, index) in d.foods"
                :key="index"
                :lang="lang"
                :langCurrent="langCurrent"
                :support-lang-list="selectLang"
                :food="i"
                @change="i = $event"
                @changeLang="langCurrent = $event"
                @removeFood="handleRemoveFood(d.foods, index)" />
          </el-form-item>

          <el-form-item style="width: 100%" v-if="!disabled">
            <el-button
                style="width: 100%;"
                icon="el-icon-circle-plus-outline"
                @click="handleAddIngredient(d.foods)"
            >{{ $t('lang.添加食材') }}
            </el-button>
          </el-form-item>

          <el-form-item :label="$t('lang.食材描述')">
            <nation-input
                :list="selectLang"
                type="textarea"
                :rows="10"
                :lang="lang"
                v-model="formData.foodDescription"
                :disabled="disabled" />
          </el-form-item>

        </div>

      </el-form>
    </div>

    <div class="btn-box">
      <el-button @click="$router.back()" v-if="disabled">{{ $t('lang.返回') }}</el-button>
      <template v-else>
        <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
        <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
      </template>
      <el-button type="primary" @click="$emit('lastStep')">
        {{ $t('lang.上一步') }}
      </el-button>
      <el-button type="primary" @click="$emit('next')">
        {{ $t('lang.下一步') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import ActionGroup from "./ActionGroup";
import NationInput from "../nation/NationInput";
import FoodIngredient from "./FoodIngredient";

export default {
  name: "FoodForm",
  components: {FoodIngredient, NationInput, ActionGroup},
  props: {
    status: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      formData: {
        portionSizeList: [],
        foodDescription: {}
      },
      disabled: false,
      lang: "",
      // 统一切换食材语言
      langCurrent: null,
      portionSizeRule: [
        {validator: this.validatorPortionSize, trigger: "blur"}
      ],
    };
  },
  activated() {
    this.$nextTick(() => {
      this.handleGetData();
    })
  },
  created() {
    this.$bus.$on("translateRecipe", () => {
      this.handleGetData();
    });
  },
  methods: {
    // 校验份量
    validatorPortionSize(rule, value, callback){
      // 只能输入正整数
      const reg = /^[1-9]\d*$/;
      const values = Object.values(value);
      if (values.some(item => !reg.test(item))) {
        return callback(new Error(this.$t('lang.请输入正确的份量')));
      }
      return callback();
    },

    // 处理提交数据
    handleFormatData() {
      const {recipeLang} = this.$store.state.recipe;
      for (const key in recipeLang) {
        recipeLang[key].foodDescription = this.formData.foodDescription[key];
      }
      return recipeLang;
    },

    // 份量失去焦点校验赋值
    handleBlurFoodSize() {
      this.formData.portionSizeList.forEach(e => {
        let portionSize = e.portionSize;
        for (const key in portionSize) {
          if(key === this.lang) continue;
          if (portionSize[this.lang] && !portionSize[key]) {
            this.$set(e.portionSize, key, portionSize[this.lang])
          }
        }
      })
    },

    handleGetData() {
      let {portionSizeList, lang} = this.$store.state.recipe;
      this.lang = lang;
      this.langCurrent = lang;
      if (portionSizeList && portionSizeList.length) {
        let list = [...portionSizeList];
        list.forEach(l => {
          if(l.foods.length) {
            l.foods = this.handleSetFoods(l.foods);
          } else {
            let {foods} = this.handleCreateDataTemplate('foods');
            l.foods = foods;
          }
        })

        this.formData.portionSizeList = [...list];
      } else {
        let obj = this.handleCreateDataTemplate();
        this.formData.portionSizeList.push(obj);
      }

      this.handleLoadFoodDesc();
    },

    //加载食材描述
    handleLoadFoodDesc() {
      let {recipeLang} = this.$store.state.recipe;
      this.recipeLang = recipeLang;
      for (const key in recipeLang) {
        this.$set(this.formData.foodDescription, key, recipeLang[key].foodDescription);
      }
    },

    // 根据语言列表设置食材输入框/选择框
    handleSetFoods(foods) {
      return foods.map(item => {
        let keys = Object.keys(item);
        this.selectLang.forEach(i => {
          if(!keys.includes(i)) {
            const formItem = {
              foodName: "",
              amount: null,
              unit: "",
            }
            this.$set(item, i, formItem);
          }
        })
        return item;
      })
    },

    // 添加食材
    handleAddIngredient(foods) {
      let obj = this.handleCreateDataTemplate("ingredient");
      obj.number = foods.length + 1;
      foods.push(obj);
    },

    // 添加份量
    handleAddDeal() {
      // let obj = this.handleCreateDataTemplate();
      // this.formData.portionSizeList.push(obj);
      let obj = JSON.parse(JSON.stringify(this.formData.portionSizeList[this.formData.portionSizeList.length - 1]));
      obj.number = Number(obj.number) + 1 + '';
      this.formData.portionSizeList.push(obj);
    },

    // 删除份量
    handleRemoveDeal(index) {
      this.formData.portionSizeList.splice(index, 1);
    },

    // 删除食材
    handleRemoveFood(foods, index) {
      foods.splice(index, 1);
    },

    handleCreateDataTemplate(type = "foods") {
      let portionSizeTemplate = {
        portionSize: {}, // 份量名称
        foods: [] // 食材数据
      }; // 份量模板

      let foodsTemplate = {
        number: "",
      };

      this.selectLang.forEach(lang => {
        let langTemplate = {
          unit: "", // 单位
          amount: null, // 数量
          foodName: "" // 食材名称
        }; // 食材模板
        foodsTemplate[lang] = langTemplate;
      });

      if (type == "foods") {
        portionSizeTemplate["foods"].push(foodsTemplate);
        return portionSizeTemplate;
      }
      return foodsTemplate;
    },
  },
  computed: {
    selectLang() {
      return this.$store.state.recipe.supportLangList || [];
    },
  },
  watch: {
    "formData.portionSizeList": {
      handler(list) {
        list = JSON.parse(JSON.stringify(list));
        let portionSizeList = list.map((item, idx) => {
          item.number = (idx + 1) + "";
          if(item.foods && Array.isArray(item.foods)) {
            item.foods.forEach((f, index) => {
              f.number = (index + 1) + "";
            })
          }
          return item;
        })
        this.$store.commit("CHANGE_RECIPE", {portionSizeList: portionSizeList})
      },
      immediate: false,
      deep: true,
    },
    "formData.foodDescription": {
      handler() {
        let recipeLang = this.handleFormatData();
        this.$store.commit('CHANGE_RECIPE', {recipeLang});
      },
      immediate: false,
      deep: true,
    },
    status: {
      handler(state) {
        if (state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.form-item-box {
  width: 600px;
  padding: 24px 12px;
  background: #f9f9f9;
  border: 1px solid #dddddd;
  border-radius: 5px;
  margin-bottom: 24px;
  position: relative;
}

.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.unit-select {
  width: 160px;
}

.input-icon,
.close-icon {
  color: red;
  font-size: 26px;
  margin-left: 14px;
}

.close-icon {
  position: absolute;
  top: 12px;
  right: 12px;
}

.add-food {
  width: 626px;
  margin-bottom: 24px;
}

.btn-box {
  width: 626px;
  display: flex;
  justify-content: center;
}
</style>
